import { createFeatureSelector, createSelector } from '@ngrx/store';
import { admissionDateFeatureKey, AdmissionDateState } from './admission-date.reducer';

export const getAdmissionDateFeature = createFeatureSelector<AdmissionDateState>(admissionDateFeatureKey);

export const getMinDate = createSelector(getAdmissionDateFeature, (state) => state.minDate);
export const getMaxDate = createSelector(getAdmissionDateFeature, (state) => state.maxDate);
